let resumeData = {
  "imagebaseurl":"images/portfolio/5.webp",
  "linkedinId":" https://www.linkedin.com/in/sky-wess-9ba370200/",
  "socialLinks":
  [
      {
        "name":"Linkedin",
        "url":"https://www.linkedin.com/in/sky-wess-9ba370200/",
        "className":"fa fa-linkedin"
      },
      {
        "name":"Bitbucket",
        "url":"https://bitbucket.org/SkyWessProjects/workspace/projects/POR",
        "className":"fa fa-bitbucket"
      }
    ],
  "aboutme":"I'm a technical designer from Arkansas currently pursuing a masters in game development and engineering from the University of Utah!  I enjoy solving difficult problems, creating engaging levels, and using player feedback to improve the game!  I am always happy to learn something new.  In my free time I enjoy making hobby art including illustration, abstract painting, and 3D modeling.  I am a big fan of RPG's, action adventure games, 3D platformers, and games where you get to explore!",
  "education":
  [
    {
      "UniversityName":"Southern Arkansas University",
      "specialization":"Computer Science: Computer Gaming and Animation Design",
      "MonthOfPassing":"August 2019 - December",
      "YearOfPassing":"2022",
      "Achievements":"3.9 GPA, Honors graduate"
    }
  ],
  "work":
  [
    {
      "CompanyName":"Murphy USA",
      "specialization":"Quality Assurance Automation Engineer I",
      "MonthOfLeaving":"January 2023 -",
      "YearOfLeaving":"Present",
      "Achievements":"Developing new automated testing tools for the QA team, including an EMV card creation/editor tool that allows the team to cover every test case for EMV cards. Communication with the development team/supervisors to determine requirements for automated testing of applications. Maintaining large codebases and updating utilities to suit current needs. Tools and technologies: C#, JavaScript, Git Bash, HTTP, Visual Studio 2019/2022, and Azure DevOps."
    },
    {
      "CompanyName":"Murphy USA",
      "specialization":"IT Intern Programmer",
      "MonthOfLeaving":"June 2022 -",
      "YearOfLeaving":"December 2022",
      "Achievements":"Developed automated testing tools for the QA team to suit the team’s current needs. Communicated with the development team and managers to determine tasks and priorities. Maintained large codebases and updated them to current technologies. Tools and technologies: C#, JavaScript, GraphQL, Git Bash, Visual Studio, and Azure DevOps."
    },
    {
      "CompanyName":"Southern Arkansas University",
      "specialization":"Data Science Research Assistant",
      "MonthOfLeaving":"Jan 2022 -",
      "YearOfLeaving":"May 2022",
      "Achievements":"Researched convolutional neural networks and ways of optimizing the resulting data. Used a large public dataset to test methods of classifying types of skin cancer images. Tested and documented optimization methods to determine which had the greatest impact. Tools and technologies: Python, Datasets, Anaconda, and Jupyter Notebook."
    },
    {
      "CompanyName":"Murphy USA",
      "specialization":"IT Intern Programmer",
      "MonthOfLeaving":"June 2021 - Jan",
      "YearOfLeaving":"2022",
      "Achievements":"Added features to existing applications and simulators at the request of the development team. Developed new frontend and backend features for existing applications. Communicated with mentors and assisted peers when they needed help with tasks. Tools and technologies: C#, C++, Restful API, Sourcetree, Visual Studio 2019, and Azure DevOps."
    }
  ],
  "skills":
  [
    {
      "skillname":"C# -  4 years"
    },
    {
      "skillname":"C++ -  4 years"
    },
    {
      "skillname":"Unity Engine -  5 years"
    },
    {
      "skillname":"Unreal Engine -  1/2 years"
    },
    {
      "skillname":"Level Design -  4 years"
    },
    {
      "skillname":"Autodesk Maya -  2 years"
    },
    {
      "skillname":"Clip Studio Paint -  4 years"
    },
    {
      "skillname":"Git -  4 years"
    },
    {
      "skillname":"Azure DevOps - 2 years"
    },
    {
      "skillname":"Python -  3 years"
    },
    {
      "skillname":"HTML5 -  2 years"
    },
    {
      "skillname":"CSS -  2 years"
    },
    {
      "skillname":"JavaScript -  2 years"
    },
    {
      "skillname":"Ranerex Studio - 1 1/2 years"
    },
  ],
  "extra":
  [
    {
      "event":"2023 Jam Anonymous",
      "role":"Programming and Level/Puzzle Design (Unreal 5)",
      "date":"June 2023",
      "Achievements":""
    },
    {
      "event":"2023 LATech Game Jam",
      "role":"Gameplay/UI Programming (Unity)",
      "date":"April 2023",
      "Achievements":""
    },
    {
      "event":"2023 Global Game Jam",
      "role":"Programming and Level Design (Unreal 5)",
      "date":"February 2023",
      "Achievements":""
    },
    {
      "event":"SAU Game Development Club",
      "role":"President, Vice President, Secretary, and General Member",
      "date":"August 2019 - December 2022",
      "Achievements":""
    },
    {
      "event":"2022 Arkansas Indie Fest",
      "role":" Presented project “Light/Shade” for public playtest",
      "date":"October 2022",
      "Achievements":""
    },
    {
      "event":"2022 Little Rock Tech Fest",
      "role":" Presented projects at SAU’s Computer Science department table",
      "date":"October 2022",
      "Achievements":""
    },
    {
      "event":"2022 Fall SAU Game Jam",
      "role":"Programming, Level Design, and Shaders (Unity)",
      "date":"September 2022",
      "Achievements":""
    },
    {
      "event":"DART Annual Conference Poster Competition",
      "role":"Presented Neural Network Research Poster, Awarded 3rd Place (undergraduate division)",
      "date":"May 2022 (Little Rock, AR)",
      "Achievements":""
    },
    {
      "event":"Computer Simulation & Gaming Conference",
      "role":"Presented Light/Shade, Awarded 1st Place for Digital Games (postsecondary division)",
      "date":"April 2022 (Tulsa, OK)",
      "Achievements":""
    },
    {
      "event":"2022 Global Game Jam",
      "role":"Programming and Level Design (Unity)",
      "date":"January 2022",
      "Achievements":""
    },
    {
      "event":"Arkansas Indie Fest",
      "role":"Presented project “Snyatcher” for Public Playtest",
      "date":"October 2021 (Magnolia, AR)",
      "Achievements":""
    },
    {
      "event":"2021 SAU Fall Game Jam",
      "role":"Organization and Design (Physical Game)",
      "date":"September 2021",
      "Achievements":""
    },
    {
      "event":"Brackey's Game Jam 2021.1",
      "role":"Programming, Level Design, Sound, and Animation (Unity)",
      "date":"February 2021",
      "Achievements":""
    },
    {
      "event":"2021 Global Game Jam",
      "role":"Level Design and Programming (Unity)",
      "date":"January 2021",
      "Achievements":""
    },
    {
      "event":"2020 Global Game Jam",
      "role":"Level Design and Programming (Unity)",
      "date":"January 2020",
      "Achievements":""
    },
    {
      "event":"2019 SAU Fall Game Jam",
      "role":"Level Design and 2D Art (Unity)",
      "date":"September 2019",
      "Achievements":""
    },
  ],
  "categories":
  [
    {
      "category":"Unreal Engine 5",
      "filtered": false,
    },
    {
      "category":"Unity Engine",
      "filtered": false,
    },
    {
      "category":"Programming",
      "filtered": false,
    },
    {
      "category":"Design",
      "filtered": false,
    },
    {
      "category":"Mobile",
      "filtered": false,
    },
    {
      "category":"VR",
      "filtered": false,
    },
    {
      "category":"Nintendo Switch",
      "filtered": false,
    },
    {
      "category":"3D Modeling",
      "filtered": false,
    },
    {
      "category":"2D Art",
      "filtered": false,
    }
  ],
  "portfolio":
  [
    {
      "name":"Everythingmart",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
        {
          "category":"Nintendo Switch",
        },
      ],
      "description":"4 player multiplayer horror game set in a strange supermarket.",
      "Studio":"Spoiled Milk Studios",
      "engine":"Unity Engine",
      "teamSize":"15",
      "Timeframe":"August 2025 - Present",
      "role":"Technical Lead, Level Designer",
      "link": "",
      "iconImg": "../images/trans.png",
      "responsibilities1": "Prototyped core systems including task system, delivery, PCG levels, and enemy behaviors in 2 months.",
      "responsibilities2": "Took levels from paper sketch to fully playable and populated, including the fresh meats and garden biomes.",
      "responsibilities3": "Facilitated cross team communication, helping team members from other disaplines communicate their needs to each other.",
      "responsibilities4": "Animated all 6 skitter creatures within engine.",
      "responsibilities5": "Optimized quality settings for the engine, materials, and textures and ported the game to Nintendo Switch.",
      "CoverImage":"images/portfolio/em1.webp",
      "Color": "rgb(252, 193, 138)",
      "BackgroundColor": "rgb(35, 33, 51)",
      "slides":
      [
        {
          "imgurl":"images/portfolio/em1.webp",
        },
        {
          "imgurl":"images/portfolio/em2.webp",
        },
        {
          "imgurl":"images/portfolio/em3.webp",
        },
        {
          "imgurl":"images/portfolio/em4.webp",
        },
        {
          "imgurl":"images/portfolio/em5.webp",
        }
      ]
  
    },
    {
      "name":"Udon Uncaged",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
      ],
      "description":"Alt-Control platformer, controlled by running in a human sized hamster ball.",
      "Studio":"Uncaged Interactive",
      "engine":"Unity Engine",
      "teamSize":"13",
      "Timeframe":"January 2025 - March 2026",
      "role":"Hardware Engineer, Technical Designer",
      "link": "https://www.youtube.com/watch?v=hEAv1nY5gTM",
      "iconImg": "../images/YoutubeLogo.png",
      "responsibilities1": "Rapidly iterated on the controller, going through over 15 designs, and building physical prototypes for 7 of them.",
      "responsibilities2": "Implemented VFX and first pass level lighting.",
      "responsibilities3": "Designed and built the final controller, primarily responsible for the carpentry aspect.",
      "responsibilities4": "Prototyped the in-game ball controller and obstacles, including spline movement for cutscenes.",
      "responsibilities5": "GDC ALT CTRL finalist, showcasing on the expo floor at Game Developer's Conference 2026.",
      "CoverImage":"images/portfolio/UU1.webp",
      "Color": "rgb(249, 176, 98)",
      "BackgroundColor": "rgb(16, 52, 90)",
      "slides":
      [
        {
          "imgurl":"images/portfolio/UU1.webp",
        },
        {
          "imgurl":"images/portfolio/UU3.webp",
        },
        {
          "imgurl":"images/portfolio/UU4.webp",
        },
        {
          "imgurl":"images/portfolio/UU5.webp",
        },
        {
          "imgurl":"images/portfolio/UU6.webp",
        }
      ]
  
    },
    {
      "name":"Gibba Gibba",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
        {
          "category":"Nintendo Switch",
        },
      ],
      "description":"3D Platforming adventure game about finding the main character's missing dog.",
      "Studio":"Studio Gibbs",
      "engine":"Unity Engine",
      "teamSize":"31",
      "Timeframe":"November 2025 - Present",
      "role":"Gameplay Programmer, Game Designer",
      "link": "https://store.steampowered.com/app/3690050/Gibba_Gibba/",
      "iconImg": "../images/steamlogo.png",
      "responsibilities1": "Polished enemy mechanics, camera behavior, player character animations, and physics interactions.",
      "responsibilities2": "Balanced platforming segments, enemy encounters, and puzzles.",
      "responsibilities3": "Optimized game settings and ported to Nintendo Switch.",
      "CoverImage":"images/portfolio/gg1.webp",
      "Color": "rgb(206, 91, 82)",
      "BackgroundColor": "rgb(59, 102, 181)",
      "slides":
      [
        {
          "imgurl":"images/portfolio/gg1.webp",
        },
        {
          "imgurl":"images/portfolio/gg2.webp",
        },
        {
          "imgurl":"images/portfolio/gg3.webp",
        }
      ]
  
    },
    {
      "name":"Neurogrow",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Mobile",
        }
      ],
      "Studio":"Therapeutic Games and Applications Lab",
      "engine":"Unity Engine",
      "teamSize":"3 (many previous developers)",
      "description":"Mobile game designed to train teachers to identify trauma responses in young children and manage their energy and relationships.",
      "Timeframe":"October 2024 - present",
      "iconImg": "../images/trans.png",
      "role":"Systems/UI Programmer",
      "responsibilities1": "Overhauled 40+ menus and UI assets to support most screen resolutions.",
      "responsibilities3": "Added support for the game to remember your preferred language.",
      "responsibilities4": "Futureproofed the game by creating prefabs of all major assets, menus, and managers.",
      "responsibilities2": "Further information and screenshots for Neurogrow are confidential due to ongoing clinical trials.",
      "CoverImage":"images/portfolio/NG1.webp",
      "Color": "#e3fff8ff",
      "BackgroundColor": "#0b674dff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/NG1.webp",
        },
        {
          "imgurl":"images/portfolio/NG2.webp",
        }
      ]
  
    },
    {
      "name":"Trauma Training Game",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
        {
          "category":"Mobile",
        }
      ],
      "Studio":"Therapeutic Games and Applications Lab",
      "engine":"Unity Engine",
      "teamSize":"3",
      "description":"Mobile game designed to train teachers to identify trauma responses in young children and manage their energy and relationships.",
      "Timeframe":"September 2024 - present",
      "iconImg": "../images/trans.png",
      "role":"Systems Designer/Programmer, UI/UX Designer/Programmer",
      "responsibilities1": "Co-developed the system design documentation to prepare us for initial prototyping.",
      "responsibilities3": "Designed and implemented the majority of the game’s menus and hud, creating custom assets when the asset pack did not meet our requirements.",
      "responsibilities4": "Created the journaling feature and save system that both read and write from a JSON file on the player’s system.",
      "responsibilities2": "Modifying the game at stakeholder request to fulfill their shifting requirements as focus group testing commences, recently fulfilled over 30 tickets to modify the game and improve user experience.",
      "CoverImage":"images/portfolio/TTG1.webp",
      "Color": "#ffefe3ff",
      "BackgroundColor": "#d98729ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/TTG1.webp",
        },
        {
          "imgurl":"images/portfolio/TTG2.webp",
        },
        {
          "imgurl":"images/portfolio/TTG3.webp",
        },
        {
          "imgurl":"images/portfolio/TTG4.webp",
        }
      ]
  
    },
    {
      "name":"Snyatcher",
      "categories":
      [
        {
          "category":"Unreal Engine 5",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
        {
          "category":"3D Modeling",
        },
        {
          "category":"2D Art",
        }
      ],
      "description":"3D platforming Cat Collectathon.",
      "Studio":"NanoLizard",
      "engine":"Unreal Engine 5",
      "teamSize":"5",
      "Timeframe":"March 2023 - present",
      "role":"Technical Designer, Gameplay Programmer, 3D Artist",
      "link": "https://store.steampowered.com/app/2699530/Snyatcher/",
      "iconImg": "../images/steamlogo.png",
      "responsibilities1": "Led the development team, organized meetings, and delegated tasks.",
      "responsibilities3": "Built the levels using Unreal's terrain and level building tools.",
      "responsibilities4": "Designed/developed the player movement mechanics, modular tools system, dialogue system, and the cat NPC behavior.",
      "responsibilities2": "Modeled, UVed, and textured 80+ props and characters.",
      "responsibilities5": "Created character creation menu for cats that allow us to copy/paste cat attributes to quickly create new cats.",
      "CoverImage":"images/portfolio/s1.webp",
      "Color": "#e88d47ff",
      "BackgroundColor": "#25201dff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/s1.webp",
        },
        {
          "imgurl":"images/portfolio/s2.webp",
        },
        {
          "imgurl":"images/portfolio/s3.webp",
        },
        {
          "imgurl":"images/portfolio/s4.webp",
        },
        {
          "imgurl":"images/portfolio/s5.webp",
        },
        {
          "imgurl":"images/portfolio/s6.webp",
        },
        {
          "imgurl":"images/portfolio/s7.webp",
        },
        {
          "imgurl":"images/portfolio/s8.webp",
        },
      ]
  
    },
    {
      "name":"Crazy Market Ultra Deluxe",
      "categories":
      [
        {
          "category":"Unreal Engine 5",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
        {
          "category":"Mobile",
        }
      ],
      "description":"Local multiplayer versus game.",
      "Timeframe":"4 Weeks",
      "role":"Level Designer, Gameplay Programmer",
      "Studio":"U of U Grad Lab",
      "engine":"Unreal Engine 5",
      "teamSize":"12",
      "link": "https://tratos.itch.io/crazy-market-ultra-deluxe",
      "iconImg": "../images/itchicon.png",
      "responsibilities1": "Designed and built 3 levels each with a unique mechanic.",
      "responsibilities2": "Created functionality for lava pits and boxes falling into them.",
      "responsibilities3": "Used mobile phone gyro controls to slide boxes across the level.",
      "responsibilities4": "Added menus and UI.",
      "CoverImage":"images/portfolio/cmud1.webp",
      "Color": "#ef5151ff",
      "BackgroundColor": "#271717ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/cmud1.webp",
        },
        {
          "imgurl":"images/portfolio/cmud2.webp",
        },
        {
          "imgurl":"images/portfolio/cmud3.webp",
        }
      ]
  
    },
    {
      "name":"You",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        }
      ],
      "description":"2D serious game.",
      "Studio":"U of U Grad Lab",
      "engine":"Unity Engine",
      "teamSize":"6",
      "Timeframe":"4 Weeks",
      "role":"Solo Programmer",
      "link": "https://owallace.itch.io/you",
      "iconImg": "../images/itchicon.png",
      "responsibilities1": "Developed the movement mechanics and shadow progression system.",
      "responsibilities2": "Created the text system that displays set dialogue on proximity.",
      "responsibilities3": "Implemented animations, VFX, and SFX.",
      "responsibilities4": "Designed ending minigame where the player has to swipe away the dialogue they've encountered.",
      "CoverImage":"images/portfolio/you1.webp",
      "Color": "#b79c91ff",
      "BackgroundColor": "#2d2321ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/you1.webp",
        },
        {
          "imgurl":"images/portfolio/you2.webp",
        },
        {
          "imgurl":"images/portfolio/you3.webp",
        },
        {
          "imgurl":"images/portfolio/you4.webp",
        }
      ]
    },
    {
      "name":"Chain Mail",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Mobile",
        }
      ],
      "description":"2D mobile/browser centipede-like arcade game.",
      "Studio":"U of U Grad Lab",
      "engine":"Unity Engine",
      "teamSize":"7",
      "Timeframe":"3 Weeks",
      "role":"Gameplay Programmer",
      "link": "https://tratos.itch.io/chain-mail",
      "iconImg": "../images/itchicon.png",
      "responsibilities1": "Implemented a mechanic that splits the chain when hit.",
      "responsibilities2": "Created mechanic allowing player to control multiple chains simultaneously.",
      "responsibilities3": "Randomized the play space on launch.",
      "responsibilities4": "Added additional visual feedback and UI juice.",
      "CoverImage":"images/portfolio/cm1.webp",
      "Color": "#48b936ff",
      "BackgroundColor": "#131813ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/cm1.webp",
        },
        {
          "imgurl":"images/portfolio/cm2.webp",
        },
        {
          "imgurl":"images/portfolio/cm3.webp",
        }
      ]
  
    },
    {
      "name":"Mr. Neopoleon Saves the World",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"2D Art",
        },
        {
          "category":"Mobile",
        }
      ],
      "description":"2D mobile idle clicker game.",
      "Timeframe":"48 hour jam - Recently continued development",
      "Studio":"NanoLizard",
      "engine":"Unity Engine",
      "teamSize":"2",
      "role":"2D Artist, Polish Programmer",
      "link": "https://timelordsnowy.itch.io/mr-neopoleon-saves-the-world",
      "iconImg": "../images/itchicon.png",
      "responsibilities1": "Created progressive character sprites for upgrades to the main character.",
      "responsibilities2": "Created background art.",
      "responsibilities3": "Hooked up animations and added juice including creating and implementing SFX.",
      "responsibilities4": "Won the Best Art Award at the 2023 LA Tech game jam.",
      "CoverImage":"images/portfolio/mr1.webp",
      "Color": "#b063cfff",
      "BackgroundColor": "#241b27ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/mr1.webp",
        },
        {
          "imgurl":"images/portfolio/mr2.webp",
        },
        {
          "imgurl":"images/portfolio/mr3.webp",
        },
        {
          "imgurl":"images/portfolio/mr4.webp",
        }
      ]
  
    },
    {
      "name":"Redumption",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
      ],
      "description":"3D Action Adventure Game.",
      "Studio":"Funky Bugs Studio",
      "engine":"Unity Engine",
      "teamSize":"18",
      "Timeframe":"3 Months",
      "role":"Technical Designer, Level Designer",
      "link": "https://store.steampowered.com/app/2226550/Redumption/",
      "iconImg": "../images/steamlogo.png",
      "responsibilities1": "Developed and maintained game design documents, and led design team meetings.",
      "responsibilities2": "Learned to resolve team conflict and design misalignment.",
      "responsibilities3": "Designed and built the level using Unity's terrain tool and assets from our art team.",
      "responsibilities4": "Programmed and designed a modular dialogue system to help us tell the game's story.",
      "responsibilities5": "Developed the cel and water shaders as well as implemented the post processing and LOD.",
      "CoverImage":"images/portfolio/r1.webp",
      "Color": "#c851a0ff",
      "BackgroundColor": "#261521ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/r1.webp",
        },
        {
          "imgurl":"images/portfolio/r2.webp",
        },
        {
          "imgurl":"images/portfolio/r3.webp",
        }
      ]
  
    },
    {
      "name":"Light/Shade",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
      ],
      "description":"Co-op Light-based Puzzle Game. Awarded 1st Place for Digital Games at CSGC 2022.",
      "Studio":"NanoLizard",
      "engine":"Unity Engine",
      "teamSize":"4",
      "Timeframe":"2 Weeks",
      "role":"Solo Programmer, Level Designer",
      "link": "https://tratos.itch.io/lightshade",
      "iconImg": "../images/itchicon.png",
      "responsibilities1": "Programmed the co-op player controller and camera, allowing the game to be player single or two player.",
      "responsibilities2": "Developed mechanics to determine if a character is or is not engulfed in shadow.",
      "responsibilities3": "Implemented the post processing, VFX, and music.",
      "responsibilities4": "Programmed the user interface, including the main menu, pause menu, and level transitions.",
      "responsibilities5": "Designed and built 5 levels that utilize the game's mechanics in interesting ways.",
      
      "CoverImage":"images/portfolio/l1.webp",
      "Color": "#efa264ff",
      "BackgroundColor": "#1f1926ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/l1.webp",
        },
        {
          "imgurl":"images/portfolio/l2.webp",
        },
        {
          "imgurl":"images/portfolio/l3.webp",
        }
      ]
    },
    {
      "name":"Paine's Furniture Emporium",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        }
      ],
      "description":"FPS (Furniture Punching Simulator).",
      "Studio":"SAU Game Lab",
      "engine":"Unity Engine",
      "teamSize":"14",
      "Timeframe":"3 Months",
      "role":"Lead Programmer, Writer, and Cutscene Animator",
      "link": "https://saugamedev.itch.io/paines-furniture-emporium",
      "iconImg": "../images/itchicon.png",
      "responsibilities1": "Lead programming meetings and divided out tasks to the programming team.",
      "responsibilities2": "Programmed the player's weapons and combat, and the enemy's health UI.",
      "responsibilities3": "Developed a system that tracks what furniture the player has collected and adds it to the player's house.",
      "responsibilities4": "Wrote, sequenced, and animated the beginning and ending scenes of the game.",
      "CoverImage":"images/portfolio/p1.webp",
      "Color": "#6067e2ff",
      "BackgroundColor": "#161821ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/p1.webp",
        },
        {
          "imgurl":"images/portfolio/p2.webp",
        },
        {
          "imgurl":"images/portfolio/p3.webp",
        }
      ]
    },
    {
      "name":"D.A.V.E",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"3D Modeling",
        },
        {
          "category":"VR",
        }
      ],
      "description":"VR Monster Destruction Game.",
      "Studio":"SAU Game Lab",
      "engine":"Unity Engine",
      "teamSize":"11",
      "Timeframe":"3 Months",
      "role":"Producer, Technical Artist, Programming Consultant",
      "link": "https://saugamedev.itch.io/dave",
      "iconImg": "../images/itchicon.png",
      "responsibilities1": "Lead weekly stand up meetings and checked in with team leads to track progress on the project.",
      "responsibilities2": "Modeled buildings and then modeled shattered versions that could be placed in game and broken.",
      "responsibilities3": "Modeled and animated the VR monster hands the player uses in game.",
      "responsibilities4": "Assisted the programming team with technical problems and bug fixing.",
      "CoverImage":"images/portfolio/d1.webp",
      "Color": "#e845acff",
      "BackgroundColor": "#1a281eff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/d1.webp",
        },
        {
          "imgurl":"images/portfolio/d2.webp",
        },
        {
          "imgurl":"images/portfolio/d3.webp",
        }
      ]
  
    },
    {"name":"Global Game Jam",
      "categories":
      [
        {
          "category":"Unreal Engine 5",
        },
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
        {
          "category":"VR",
        }
      ],
      "description":"Yearly participation in the Global Game Jam since 2020.",
      "iconImg": "../images/trans.png",
      "responsibilities1": "Re-Pair Game RPG (2020), Programmer, Unity Engine: https://v3.globalgamejam.org/2020/games/re-pair-game-rpg-1",
      "responsibilities2": "Proto-Snyatcher (2021), Level Designer + Programmer, Unity Engine: https://v3.globalgamejam.org/2021/games/snyacher-2",
      "responsibilities3": "Light/Shade (2022), Solo Programmer + Level Designer, Unity Engine: https://tratos.itch.io/lightshade (More on light/shade in portfolio)",
      "responsibilities4": "The Undergrowth (2023), Solo Programmer, Unreal Engine 5: https://v3.globalgamejam.org/2023/games/undergrowth-1",
      "responsibilities5": "Grillarous (2024), Level Designer + Gameplay Programmer, Unreal Engine 5: https://globalgamejam.org/games/2024/grillarious-9",
      "responsibilities6": "Crystal x Pearl Bubble Tea (2025), Gameplay Programmer + Level Designer, Unity Engine: https://globalgamejam.org/games/2025/crystal-x-pearl-bubble-tea-7",
      "CoverImage":"images/portfolio/gr1.webp",
      "Color": "#f6fa84ff",
      "BackgroundColor": "#342439ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/cpbt2.webp",
        },
        {
          "imgurl":"images/portfolio/cpbt3.webp",
        },
        {
          "imgurl":"images/portfolio/gr1.webp",
        },
        {
          "imgurl":"images/portfolio/gr3.webp",
        },
        {
          "imgurl":"images/portfolio/TU2.webp",
        },
        {
          "imgurl":"images/portfolio/s4.webp",
        },
        {
          "imgurl":"images/portfolio/s5.webp",
        },
        {
          "imgurl":"images/portfolio/u8.webp",
        },
      ]
  
    },
    {
      "name":"Jam Anonymous Summer Game Jam",
      "categories":
      [
        {
          "category":"Unreal Engine 5",
        },
        {
          "category":"Unity Engine",
        },
        {
          "category":"Programming",
        },
        {
          "category":"Design",
        },
      ],
      "description":"Orgainizer and participant for yearly 48 hour summer game jam.",
      "iconImg": "../images/trans.png",
      "responsibilities1": "Co-host for this annual summer game jam, typically held in June each year.",
      "responsibilities2": "Feed the Light (2023), Gameplay Programmer + Level Designer, Unreal 5: https://stargaze-axl.itch.io/feed-the-light",
      "responsibilities3": "Drax Evasion (2024), Gameplay Programmer, Godot: https://quinneakes.itch.io/drax-evasion",
      "responsibilities4": "Creature Cannon (2025), Gameplay Programmer, Unity: https://tratos.itch.io/creature-cannon",
      "CoverImage":"images/portfolio/FTL6.webp",
      "Color": "#ed6a49ff",
      "BackgroundColor": "#542d72ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/FTL4.webp",
        },
        {
          "imgurl":"images/portfolio/FTL6.webp",
        },
        {
          "imgurl":"images/portfolio/DE.webp",
        },
        {
          "imgurl":"images/portfolio/CC1.webp",
        },
        {
          "imgurl":"images/portfolio/CC2.webp",
        }
      ]
  
    },
    {
      "name":"3D Modeling Work",
      "categories":
      [
        {
          "category":"3D Modeling",
        }
      ],
      "description":"Various 3D Model related works.",
      "Timeframe":"2022 - present",
      "iconImg": "../images/trans.png",
      "CoverImage":"images/portfolio/TrayCollage.webp",
      "Color": "#b00b69",
      "BackgroundColor": "#1a1415ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/TrayCollage.webp",
        },
        {
          "imgurl":"images/portfolio/KassCollage.webp",
        },
        {
          "imgurl":"images/portfolio/Plants.webp",
        },
        {
          "imgurl":"images/portfolio/Env.webp",
        },
        {
          "imgurl":"images/portfolio/CollageGranny.webp",
        }
      ]
  
    },
    {
      "name":"2D Art Work",
      "categories":
      [
        {
          "category":"2D Art",
        }
      ],
      "description":"Various 2D artwork and painting related works.",
      "Timeframe":"2020 - present",
      "iconImg": "../images/trans.png",
      "CoverImage":"images/portfolio/EmiCollage.webp",
      "Color": "#b00b69",
      "BackgroundColor": "#1a1415ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/1.webp",
        },
        {
          "imgurl":"images/portfolio/3.webp",
        },
        {
          "imgurl":"images/portfolio/4.webp",
        },
        {
          "imgurl":"images/portfolio/5.webp",
        },
        {
          "imgurl":"images/portfolio/6.webp",
        },
        {
          "imgurl":"images/portfolio/7.webp",
        },
        {
          "imgurl":"images/portfolio/u2.webp",
        },
        {
          "imgurl":"images/portfolio/20.webp",
        },
        {
          "imgurl":"images/portfolio/18.webp",
        },
        {
          "imgurl":"images/portfolio/11.webp",
        },
        {
          "imgurl":"images/portfolio/CollageTray1.webp",
        },
        {
          "imgurl":"images/portfolio/CollageEmi.webp",
        },
        {
          "imgurl":"images/portfolio/EmiCollage.webp",
        },
        {
          "imgurl":"images/portfolio/15.webp",
        },
        {
          "imgurl":"images/portfolio/14.webp",
        },
        {
          "imgurl":"images/portfolio/16.webp",
        },
        {
          "imgurl":"images/portfolio/17.webp",
        }
      ]
  
    },
    {
      "name":"Old Prototypes / Uncatigorized Jams",
      "categories":
      [
        {
          "category":"Unity Engine",
        },
        {
          "category":"Design",
        },
        {
          "category":"Programming",
        },
        {
          "category":"2D Art",
        }
      ],
      "description":"Various old projects.",
      "Timeframe":"2019 - 2022",
      "role":"Programmer, 2D Artist, Level Designer",
      "iconImg": "../images/trans.png",
      "CoverImage":"images/portfolio/12.webp",
      "Color": "#b00b69",
      "BackgroundColor": "#1a1415ff",
      "slides":
      [
        {
          "imgurl":"images/portfolio/u2.webp",
        },
        {
          "imgurl":"images/portfolio/u3.webp",
        },
        {
          "imgurl":"images/portfolio/u4.webp",
        },
        {
          "imgurl":"images/portfolio/u5.webp",
        },
        {
          "imgurl":"images/portfolio/u7.webp",
        },
        {
          "imgurl":"images/portfolio/u9.webp",
        },
        {
          "imgurl":"images/portfolio/12.webp",
        },
        {
          "imgurl":"images/portfolio/13.webp",
        }
      ]
  
    }
  ],
  "uportfolio":
  [
    {
      "name":"The Undergrowth",
      "description":"3D Stealth Survival Game",
      "Timeframe":"48 Hours",
      "role":"Programmer and Level Designer. Unreal Engine 5",
      "imgurl":"images/portfolio/TU2.webp"
    },
    {
      "name":"Level design Practice 1",
      "description":"A small isometric 3D swamp.",
      "Timeframe":"1 Week",
      "role":"Level Designer. Unity Engine",
      "imgurl":"images/testimonials-bg.webp"
    },
    {
      "name":"The Possessed  - 2021 Fall SAU Game Jam",
      "description":"A card game where you use card abilities to find out who is possessed.",
      "Timeframe":"36 Hours",
      "role":"Card Illustrator and Mechanics Designer.",
      "imgurl":"images/portfolio/u2.webp"
    },
    {
      "name":"A Guide to Getting Famous - Game Development Final",
      "description":"Help these 3 content creators make it big.",
      "Timeframe":"2 Weeks",
      "role":"Lead Programmer, Character Sprite Artist, and Level Designer. Unity Engine",
      "imgurl":"images/portfolio/u3.webp"
    },
    {
      "name":"Level design Practice 2 - Game Development Midterm",
      "description":"A small floating island with a hidden subplot.",
      "Timeframe":"1 Week",
      "role":"Level Designer. Unity Engine",
      "imgurl":"images/portfolio/u4.webp"
    },
    {
      "name":"Tamagotchi Clone - Fundamentals of Game Programming 1",
      "description":"A critter care game.",
      "Timeframe":"1 Week",
      "role":"Programmer and Pixel Artist. Unity Engine",
      "imgurl":"images/portfolio/u5.webp"
    },
    {
      "name":"Just a Game Without a Name - Brackey's Game Jam 2021.1",
      "description":"A little astronaut experiences several genre shifts.",
      "Timeframe":"1 Week",
      "role":"Programmer and Level Designer. Unity Engine",
      "imgurl":"images/portfolio/u7.webp"
    },
    {
      "name":"Re-pair Game (RPG) - Global Game Jam 2020",
      "description":"Repairing a game from the inside.",
      "Timeframe":"48 Hours",
      "role":"Level Designer and Programmer. Unity Engine",
      "imgurl":"images/portfolio/u8.webp"
    },
    {
      "name":"Never Noir - 2019 Fall SAU Game Jam",
      "description":"A detective investigates a secret research facility.",
      "Timeframe":"2 Months",
      "role":"Level Designer and Programmer. Unity Engine",
      "imgurl":"images/portfolio/u9.webp"
    },
  ],
}

export default resumeData
